export const MUNICIPAL_PROPERTY_REGISTER_LIST_PATH = "registers";
